module.exports = __webpack_public_path__ + "static/media/conffeti-bg-dark.b345b139.png";